import axios, { AxiosResponse } from 'axios';

const questionnaireUrl = '/services/isnaportalsync/api/ogd-questionnaire';

export const getQuestionnaireList = (
    tokenStr: string,
    lang: string,
    params?: Record<string, any>,
): Promise<AxiosResponse> => {
    return axios.get(`${questionnaireUrl}?lang=${lang}`, {
        headers: { Authorization: `${tokenStr}` },
        params: params,
    });
};

export const saveQuestionsResult = (
    questionId: any,
    tokenStr: string,
    request: any[],
    lang: string,
): Promise<AxiosResponse> => {
    return axios.post(`${questionnaireUrl}/pass/${questionId}?lang=${lang}`, request, {
        headers: { Authorization: `${tokenStr}` },
    });
};

export const getPassedQuestionnaire = (
    questionnaireId: number,
    tokenStr: string,
): Promise<AxiosResponse> => {
    return axios.get(`${questionnaireUrl}/passed/${questionnaireId}`, {
        headers: { Authorization: `${tokenStr}` },
    });
};

export const getChartsData = (
    questionnaireId: number,
    lang: string,
    tokenStr: string,
): Promise<AxiosResponse> => {
    return axios.get(`${questionnaireUrl}/statistic/${questionnaireId}?lang=${lang}`, {
        headers: { Authorization: `${tokenStr}` },
    });
};

export const getActiveQuestionnaireNumber = (
    tokenStr: string,
): Promise<AxiosResponse> => {
    return axios.get(`${questionnaireUrl}/new`, {
        headers: { Authorization: `${tokenStr}` },
    });
};
